import { ALL_SUPPORTED_CHAIN_IDS } from 'constants/chains'
import { RPC_URLS } from 'constants/networks'
import { ducxMainnet } from 'constants/networks/custom-networks'
import { createConfig } from 'wagmi'

import { buildTransports, PROVIDER_POLLING_INTERVAL } from './transports'

export const wagmiConfig = createConfig({
  chains: [ducxMainnet],
  multiInjectedProviderDiscovery: false,
  transports: buildTransports({
    chainIds: ALL_SUPPORTED_CHAIN_IDS,
    rpcUrls: RPC_URLS,
  }),
  batch: {
    multicall: false,
  },
  pollingInterval: PROVIDER_POLLING_INTERVAL,
})
